import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as nodesApi from '../api/nodes';
import * as usersApi from '../api/users';
import type { NodeResponse, CreateNodeRequest, UpdateNodeRequest, UserResponse, UpdateUserRequest } from '../api/types';

export function useNodes() {
  return useQuery({
    queryKey: ['nodes'],
    queryFn: async () => {
      const res = await nodesApi.getNodes();
      if (res.code !== 0) throw new Error(res.message);
      return res.data;
    },
  });
}

export function useCreateNode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateNodeRequest) => nodesApi.createNode(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['nodes'] }),
  });
}

export function useUpdateNode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateNodeRequest }) =>
      nodesApi.updateNode(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['nodes'] }),
  });
}

export function useDeleteNode() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => nodesApi.deleteNode(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['nodes'] }),
  });
}

export function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      const res = await usersApi.getUsers();
      if (res.code !== 0) throw new Error(res.message);
      return res.data;
    },
  });
}
